var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.52 19.02v2.46H9.73v-2.46zm6.21 6.21V11.52H7.27v13.71zm0-19.98q1.02 0 1.77.75c.75.75.75 1.09.75 1.77v17.46q0 1.02-.75 1.77c-.75.75-1.09.75-1.77.75H7.27q-1.05 0-1.785-.75c-.735-.75-.735-1.09-.735-1.77V7.77q0-1.02.735-1.77c.735-.75 1.085-.75 1.785-.75H8.5V2.73h2.52v2.52h9.96V2.73h2.52v2.52zm-2.46 8.73v2.52H9.73v-2.52z"
})));
export default SvgTimeline;